module.exports = __webpack_public_path__ + "static/media/LV2@2x.30e5a0a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/LV/LV2@2x.png
// module id = 675
// module chunks = 0